

















































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { mapGetters, mapState } from "vuex";
import { formatDate } from "@/lib/date";
import { prepareMoney } from "@/assets/scripts/utils";
import { ContractActsByContract } from "@/models/contract";
import XDataTable from "../hoc/Table.vue";
import ActionDropdownAct from "./ActionDropdownAct.vue";
import XButton from "../SimpleButton.vue";

@Component({
  components: {
    XDataTable,
    ActionDropdownAct,
    XButton,
  },
  computed: {
    ...mapState({ appEnvironment: "appEnvironment" }),
    ...mapGetters({ contractId: "contract/id" }),
  },
  filters: {
    formatDate(value: string): string {
      return formatDate(value, "full");
    },
    prepareMoney,
  },
})
class ContractActTable extends Vue {
  [x: string]: any;

  @Prop({ required: true }) readonly documents!: ContractActsByContract[];

  headers = [
    { text: "Дата", value: "date", width: "12.5%" },
    { text: "Номер", value: "number", width: "12.5%" },
    { text: "Период", value: "period", width: "18.8%" },
    { text: "Дебет по данным продавца", value: "pr_deb", width: "12.5%" },
    { text: "Кредит по данным продавца", value: "pr_kr", width: "12.5%" },
    { text: "Дебет по данным покупателя", value: "pok_deb", width: "12.5%" },
    { text: "Кредит по данным покупателя", value: "pok_kr", width: "12.5%" },
    { text: "Статус", value: "status", width: "15" },
  ];

  docKeys = [
    "дата",
    "номер",
    ["периодс", "периодпо"],
    "суммадтпродавец",
    "суммактпродавец",
    "суммадтпокупатель",
    "суммактпокупатель",
    "статус",
  ];

  selectedAll = false;
  selectedRows: boolean[] = [];

  public get preparedHeaders() {
    return [
      ...this.headers,
      { text: "", value: "action", width: "7.5%" },
    ];
  }

  public get preparedDocuments() {
    return this.documents.map((document) => {
      const docValues = this.docKeys.map((keyByTd) => {
        return Array.isArray(keyByTd)
          ? keyByTd.map((key) => document[key])
          : document[keyByTd];
      });

      // Пустая строка, как последний элемент массива позволяет использовать дропдаун
      // в каждой заключительной ячейке строки таблицы.
      return [...docValues, ""];
    });
  }

  isEndStatus(index) {
    return (this.documents[index]["статускод"] || "") != "";
  }

  @Emit()
  public propagateDocumentEvt(evtName: string, index: number) {
    this.$emit(evtName, this.documents[index]["документ"]);
  }
}

export default ContractActTable;
